// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';


const TableContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin: auto;
  color: #b8b8b8;
  text-align: center;
`;

const StyledTable = styled.table.attrs({className: 'table-striped'})`
  width: 100%;
  text-align: center;
  border-color: #261d12 !important;
  margin-bottom: 1rem;

  &.table-striped > tbody > tr:nth-of-type(odd) {
    background-color: rgb(245 64 114 / 12%);
  }
`;

const StyledP = styled.p.attrs({className: 'text-center'})`
  color: #fff;
`;

const StatisticsTable = ({stats, serverName}) => {


  return (
    <>
      <StyledP>{serverName}</StyledP>
      <TableContainer>
        <StyledTable as="table">
          <tbody>
            {stats.map((stat, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'left' }}>{stat.label}</td>
                <td
                  style={{
                    textAlign: 'right',
                    color:
                      stat.label === 'Server Status' && stat.value === 'Online'
                        ? 'green'
                        : stat.label === 'Server Status' && stat.value === 'Offline'
                        ? 'red'
                        : 'inherit',
                  }}
                >
                  {stat.value}
                </td>
              </tr>
            ))}
          </tbody>
        </StyledTable>
      </TableContainer>
    </>
  );
};

export default StatisticsTable;
